import React from "react"
import ReactDOM from "react-dom/client"
import Application from "./applications/Application"

import "./index.css"
import "./i18n/i18n"

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
)
